import { MissionAcceptanceStatus } from '@enums/mission-acceptance-status.enum';

export const MISSION_ACCEPTANCE_STATUS_LABEL: Record<MissionAcceptanceStatus, string> = {
  [MissionAcceptanceStatus.todo]: 'À faire',
  [MissionAcceptanceStatus.inProgress]: 'En cours',
  [MissionAcceptanceStatus.toValidate]: 'À valider',
  [MissionAcceptanceStatus.validated]: 'Validée',
  [MissionAcceptanceStatus.ignored]: 'Ignorée'
};
